import { z } from "zod";

export const getAllGlobalsSchema = z.object({
    default_vat_rate: z.number()
});

export type getAllGlobalsSchemaType = z.infer<typeof getAllGlobalsSchema>;